import { EntityTypeEnum } from '@sr-sdks/api-sdk-axios';
import * as yup from 'yup';

/**
 * Internal submit gate (no visible UI). Must be true unless the country is
 * non-AU or the entity is an Individual — i.e. AU businesses cannot submit an
 * unverified ABN until they either pass lookup or explicitly proceed.
 *
 * Ported verbatim from packages/frontend/src/schema/workspaceSchema.ts:57-79
 * (canProceed: yup.bool().when(['businessNumberCountry','entityType'], ...)).
 */
export const canProceedSchema = yup
  .bool()
  .when(
    ['businessNumberCountry', 'entityType'],
    ([businessNumberCountry, entityType], schema) =>
      schema.test(
        'business-number-proceed-status',
        (value, { createError, path }) => {
          if (
            value ||
            businessNumberCountry !== 'AU' ||
            entityType === EntityTypeEnum.Individual
          ) {
            return true;
          }

          return createError({ message: 'Proceed is required', path });
        },
      ),
  );
